/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

const section4MedicalTypes = [MedicalTypeIds.NightWorker];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
export const section4Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.OfficeDuties,
        questionText: "Office Duties",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.OfficeDutiesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.Driving,
        questionText: "Driving",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.DrivingFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.ManualHandling,
        questionText: "Manual Handling",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.ManualHandlingFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.OperatingMachinery,
        questionText: "Operating Machinery",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.OperatingMachineryFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.TypicalPatternNightWork,
        questionText: "Night work is work, which includes the period between 11.00pm and 06:00am. Please describe your typical pattern of night work e.g. number of hours worked per night, number of nights worked per week / month.",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.HealthSymptomsCausedByNightWork,
        questionText: "Do you currently have any health symptoms which you think are caused by night work, or that are made worse by night work?",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.HealthSymptomsCausedByNightWorkFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.RegularPillsOrMedication,
        questionText: "Do you take any tablets, pills or medicine regularly? (Include any sleeping tablets and injections).",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.RegularPillsOrMedicationFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.AttendingHospitalGpReceivingMedicalTreatment,
        questionText: "Are you attending hospital or your GP or receiving any medical treatment at the present time?",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.AttendingHospitalGpReceivingMedicalTreatmentFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.CardiovascularProblems,
        questionText: "Cardiovascular problems",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.CardiovascularProblemsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.ExpectantMother,
        questionText: "Are you a new or expectant mother?",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.ExpectantMotherFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.NightWorkerHasPreviouslyDisclosedSameMedicalCondition,
        questionText: "If you have disclosed a medical condition have you disclosed the same condition on any previous nightworker questionnaires?",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.NightWorkerHasPreviouslyDisclosedSameMedicalConditionChanges,
        questionText: "Has anything changed with your condition, symptoms or medication since you last disclosed the condition?",
        medicalTypes: section4MedicalTypes
    },
    {
        id: questionIds.NightWorkerPreviouslyDisclosedSameMedicalConditionChanges,
        questionText: "Please provide details",
        medicalTypes: section4MedicalTypes
    }
];
/* eslint-enable max-len */
